import { useCallback } from 'react';
import useMatchMedia from 'hooks/useMatchMedia';

export default function usePress({
  onPressStart,
  onPressEnd,
}: {
  onPressStart?: () => void;
  onPressEnd?: () => void;
}) {
  const isTouchDevice = useMatchMedia('isTouchDevice');

  const handleStart = useCallback(() => {
    onPressStart?.();
  }, [onPressStart]);

  const handleEnd = useCallback(() => {
    onPressEnd?.();
  }, [onPressEnd]);

  if (isTouchDevice) {
    return {
      onTouchStart: handleStart,
      onTouchEnd: handleEnd,
    };
  }

  return {
    onMouseEnter: handleStart,
    onMouseLeave: handleEnd,
  };
}
